<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { type ObjectsListItemMap, ObjectTypes } from '@/entities/Object'
import { VIcons } from '@/shared/ui'
import { GroupControl } from '@/features/Group/Cabinet/GroupControl'

const props = defineProps({
  items: {
    type: Array as PropType<ObjectsListItemMap[]>,
    required: true,
  },
})

/**
 * Вычисляем типы выделенных объектов и их количество
 */
const typesWithCount = computed(() => {
  const result: Map<number, { name: string; count: number; ids: number[] }> = new Map()

  props.items?.forEach((item) => {
    const resultItem = result.get(item.object_type_id)

    if (resultItem) {
      resultItem.count++
      resultItem.ids.push(item.id)
    } else {
      result.set(item.object_type_id, {
        name: ObjectTypes[item.object_type_id].name,
        count: 1,
        ids: [item.id],
      })
    }
  })

  return result
})
</script>

<template>
  <VExpansionPanel v-if="items.length" density="compact" :min-width="300" :max-width="500">
    <template #title>
      <div class="w-object-map-info-item__header">
        <div class="w-object-map-info-item__title">
          <VIcons type="stack" class="w-object-map-info-item__icon_default" />

          {{ $t('itf.selected_objects_count', { count: items.length }) }}
        </div>
      </div>
    </template>

    <template #text>
      <div class="w-object-map-info-item__row" v-for="[key, value] in typesWithCount" :key>
        <span>{{ value.name }} ({{ value.count }})</span>

        <GroupControl v-if="key === 1" :object_ids="value.ids" />
      </div>
    </template>
  </VExpansionPanel>
</template>
